import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-link-strategies',
  templateUrl: './link-strategies.component.html',
  styleUrls: ['./link-strategies.component.css']
})
export class LinkStrategiesComponent implements OnInit {

  @Input() onShowPeriod;

  circle: String;
  toggleDiagram: Boolean = false;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/Myrberg/Documents/spring_repo1/spring-app/src/app/base/components/kanban/components/link-strategies/link-strategies.component.ts